import VueRouter from "vue-router"
// import Index from '../pages/index.vue'
import Home from '../pages/home2.vue'
import Detail1 from '../pages/Detail.vue'
import Detail2 from '../pages/Detail2.vue'
import Detail3 from '../pages/Detail3.vue'
import Detail4 from '../pages/Detail/Detail4.vue'
import Detail5 from '../pages/Detail/Detail5.vue'
import Detail6 from '../pages/Detail/Detail6.vue'
import Detail7 from '../pages/Detail/Detail7.vue'
import Detail8 from '../pages/Detail/Detail8.vue'
import Detail9 from '../pages/Detail/Detail9.vue'
import Detail10 from '../pages/Detail/Detail10.vue'
import PuzzleDetail from '../pages/Detail/PuzzleDetail.vue'
import PatrioticDetail from '../pages/Detail/PatrioticDetail.vue'
import ScienceDetail from '../pages/Detail/ScienceDetail.vue'
import MonkeyDetail from '../pages/Detail/monkeyDetail.vue'
import LifeDetail from '../pages/Detail/lifeDetail.vue'
import Classify from '../pages/classify.vue'
import Introduce from '../pages/introduce.vue'
import About from '../pages/about.vue'
import Privacy from '../pages/privacy.vue'
import Report from '../pages/new/report.vue'
import Certifate from '../pages/new/certifate.vue'
import Icp from '../pages/new/icp.vue'
import License from '../pages/new/license.vue'
import CommonDetail from '../pages/Detail/commonDetail.vue'

const routes = [
  {
    path: '/',
    name: 'main',
    redirect: 'index'
  },
  {
    path: '/index',
    name: 'index',
    component: Home
  },
  {
    path: '/detail1',
    name: 'detail1',
    component: Detail1
  },
  {
    path: '/detail2',
    name: 'detail2',
    component: Detail2
  },
  {
    path: '/detail3',
    name: 'detail3',
    component: Detail3
  },
  {
    path: '/detail4',
    name: 'detail4',
    component: Detail4
  },
  {
    path: '/detail5',
    name: 'detail5',
    component: Detail5
  },
  {
    path: '/detail6',
    name: 'detail6',
    component: Detail6
  },
  {
    path: '/detail7',
    name: 'detail7',
    component: Detail7
  },
  {
    path: '/detail8',
    name: 'detail8',
    component: Detail8
  }, {
    path: '/detail9',
    name: 'detail9',
    component: Detail9
  }, {
    path: '/detail0',
    name: 'Detail10',
    component: Detail10
  }, {
    path: '/detail0',
    name: 'Detail10',
    component: Detail10
  }, {
    path: '/puzzleDetail/:id',
    name: 'PuzzleDetail',
    component: PuzzleDetail
  }, {
    path: '/patrioticDetail',
    name: 'PatrioticDetail',
    component: PatrioticDetail
  }, {
    path: '/scienceDetail',
    name: 'ScienceDetail',
    component: ScienceDetail
  }, {
    path: '/monkeyDetail',
    name: 'MonkeyDetail',
    component: MonkeyDetail
  }, {
    path: '/lifeDetail',
    name: 'LifeDetail',
    component: LifeDetail
  }, {
    path: '/classify',
    name: 'Classify',
    component: Classify
  }, {
    path: '/introduce',
    name: 'Introduce',
    component: Introduce
  }, {
    path: '/about',
    name: 'About',
    component: About
  }, {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  }, {
    path: '/report',
    name: 'Report',
    component: Report
  }, {
    path: '/commonDetail',
    name: 'CommonDetail',
    component: CommonDetail
  }, {
    path: '/certifate',
    name: 'Certifate',
    component: Certifate
  }, {
    path: '/icp',
    name: 'Icp',
    component: Icp
  }, {
    path: '/icp',
    name: 'Icp',
    component: Icp
  }, {
    path: '/license',
    name: 'License',
    component: License
  }, 
]


const router = new VueRouter({
  routes // (缩写) 相当于 routes: routes
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router